<template>
  <v-container fluid class="talktrend-persona ma-0 pa-6">
    <v-row class="ma-0 pa-0">
      <v-col
        v-if="normalizedSections.length === 0"
        cols="12"
        class="talktrend-persona__empty ma-0 pa-0"
      >
        <span>No persona details are available for this audience.</span>
      </v-col>
      <v-col
        v-for="section in normalizedSections"
        :key="section.title"
        cols="12"
        class="talktrend-persona__section ma-0 px-0 py-3"
      >
        <div class="talktrend-persona__title">{{ section.title }}</div>
        <div class="talktrend-persona__text">{{ section.text }}</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "TalkTrendPersonaPage",
  props: {
    personaSections: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    normalizedSections: function () {
      return (this.personaSections || [])
        .map((section) => {
          if (!Array.isArray(section) || section.length < 2) {
            return null;
          }

          const title = section[0] == null ? "" : String(section[0]).trim();
          const text = section[1] == null ? "" : String(section[1]).trim();

          if (!title && !text) {
            return null;
          }

          return {
            title: title || "Persona",
            text,
          };
        })
        .filter(Boolean);
    },
  },
};
</script>

<style scoped>
.talktrend-persona {
  color: #1b1b1b;
  min-height: 100%;
  width: 100%;
}

.talktrend-persona__empty {
  align-items: center;
  color: #777777;
  display: flex;
  font-family: "Poppins";
  font-size: 1rem;
  justify-content: center;
  min-height: 240px;
}

.talktrend-persona__section {
  border-bottom: 1px solid #e5e5e5;
}

.talktrend-persona__title {
  font-family: "Poppins";
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 8px;
}

.talktrend-persona__text {
  font-family: "Poppins";
  font-size: 0.95rem;
  line-height: 1.6;
  white-space: pre-line;
}
</style>
